import { StyleSheet } from 'react-native';

import {
    heightPercentageToDP,
    widthPercentageToDP,
} from 'utils/responsiveness';

import { ImageSize } from 'components/NagraImage/types';

const styles = StyleSheet.create({
    container: {
        flexDirection: 'row',
        justifyContent: 'flex-start',
        width: '100%',
        minHeight: heightPercentageToDP(56),
        marginBottom: heightPercentageToDP(8),
        paddingLeft: widthPercentageToDP(16),
    },
    logo: { width: ImageSize.SETTINGS_LIST_CHANNEL_LOGO.width },
});

export default styles;
